import API from '@aws-amplify/api';
import { I18n } from 'aws-amplify';
import { Storage } from 'aws-amplify';
import { createNewTicket, editTicket, createTicket, saveTicketDraft, sendTicketFromDraft,createAnonymousQa, createTicketByUploadCsv } from '@/graphql/mutations';
import Constant from '@/common/constant/Constant';
import {
    getTicketDetail,
    getTicketList,
    queryTicketGSI3,
    prepareDataForTicketDetail,
    getTicketPdfDetail,
    getTicketCustomerList,
    getTicketHelpDeskDrillDownSearch,
    getTicketListDetail,
    getTicketKnowledgePrompt,
    executeQueryEls
    // bulkUpdateTicket
} from '@/graphql/queries';
import {
    bulkUpdateTicket
} from '@/graphql/mutations';
import * as queries from '@/graphql/queries';
import { updateTicket, deleteTicket, removeTicket } from '@/graphql/mutations';
import Utils from '@/common/utils/utils';
import Logger from '@/common/utils/Logger';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { uploadFileToS3 } from '@/component/common/UploadFiles';
import { hasKnowledgeChatPermissionInChatThread } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import { prepareParamsGetTicketDataGSI3WithFilter, prepareParamsQueryTicketInviteExternalDeskList, prepareParamsQueryTicketListAssignToUser } from './dynamoDBRequestDto/DynamoDBTicketRequestDto';
import * as DynamoDBTicketRequestDto from './dynamoDBRequestDto/DynamoDBTicketRequestDto';
import { getCustomerProjectByCorporation, getProjectById } from './projectService';
import { getCorporationById } from '@/service/organizationService';
import { cloneDeep } from 'lodash';
import { getPublicAPI } from './publicService';
const { AUTH_TYPE } = require('aws-appsync');

/**
 * Get ticket help desk list
 * @param {*} APIClient 
 * @param {*} params 
 * @returns ticketHelpDeskList
 */
export const getTicketHelpDeskList = async (APIClient, params) => {
    let ticketHelpDeskList = [];
    let queryParams = {
        query: queries.getTicketHelpDeskList,
        variables: {
            params: params,
        },
    };
    let queryResult = await API.graphql(queryParams);
    let results = queryResult.data.getTicketHelpDeskList || {};
    ticketHelpDeskList = results?.ticketHelpDeskListInfo || [];
    let totalTickets = results?.totalTickets || 0;

    return {ticketHelpDeskList: ticketHelpDeskList, totalTickets: totalTickets};
};



export const getTicketListQuery = async (APIClient, params) => {
    try {
        let queryParams = {
            query: getTicketCustomerList,
            variables: {
                params: params,
            },
        };

        let queryResult = await API.graphql(queryParams);
        let listTicket = !Utils.isEmptyObject(queryResult.data.getTicketCustomerList)
            ? queryResult.data.getTicketCustomerList
            : { responseTicketList: [], responseHelpDeskList: [] };
        // detail ticket list
        let detailTicketList = [];
        await Promise.all(
            listTicket.responseTicketList.map(async (ticket) => {
                if (!Utils.isEmpty(ticket.lastMessageInfo)) {
                    // call s3
                    let userDetail = Utils.isEmpty(ticket.lastMessageInfo?.userDetail)
                            ? {}
                            : JSON.parse(ticket.lastMessageInfo.userDetail);
                    let fullName = Utils.getFullNameOfUser(
                        Constant.LANGUAGE_TYPE.JP,
                        userDetail
                    );
                    let shortFullName = Utils.isEmptyString(fullName)
                        ? ''
                        : fullName.substring(0, 2);
                    ticket.lastMessageInfo.shortFullName = shortFullName;
                    ticket.lastMessageInfo.fullName = fullName;
                    if (ticket.lastMessageInfo.avatar !== Constant.AVATAR_DEFAULT) {
                        // use S3Image tag
                        // let avatar = await Storage.get(ticket.lastMessageInfo.avatar);
                        // ticket.lastMessageInfo.avatar = avatar;
                        ticket.lastMessageInfo.shortFullName = '';
                    } 
             
                    // build messsage
                    let message = ticket.lastMessageInfo.message;
                    switch (ticket.lastMessageInfo.message) {
                        case Constant.POST_TYPE.IMAGE:
                            message = I18n.get('USER04MSG021');
                            break;
                        case Constant.POST_TYPE.FILE:
                            message = I18n.get('USER04MSG020');
                            break;
                        default:
                            // todo
                            break;
                    }
                    ticket.lastMessageInfo.message = message;
                }

                if (!Utils.isEmptyObject(ticket?.personInChargeInfo) && ticket?.personInChargeInfo?.avatar) {
                    let assigneeAvatar = await Storage.get(ticket.personInChargeInfo.avatar);
                    ticket.personInChargeInfo.avatar = assigneeAvatar;
                }

                detailTicketList.push(ticket);
                return ticket;
            })
        );

        // build result
        listTicket.responseTicketList = detailTicketList;

        return listTicket;
    } catch (err) {
        Logger.error('getTicketListQuery', err);
        return null;
    }
};

export const getTicketInviteExternalDeskList = async (APIClient, organizationId, projectId) => {
    try {
        const dynamodbExpression = prepareParamsQueryTicketInviteExternalDeskList(Constant.TICKET_USAGE.REQ, organizationId, projectId)
        let params = {
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbExpression)
                }
            },
        };

        let resData = await API.graphql(params);
        return resData.data.getTicketList;
    } catch (err) {
        Logger.error('getTicketListForHelpDeskSide', err);
        return null;
    }
};

/**
 * getTicketById
 * @param {*} API 
 * @param {*} id 
 * @returns 
 */
export const getTicketById = async (APIClient, id, checkBlockAndDeleteOrg = null, authen = true, checkIsValidAiAutoTicket = false) => {
    let ticketDetail = {};

    let params = {
        id: id
    }
    
    if (checkBlockAndDeleteOrg) {
        params.checkBlockAndDeleteOrg = true;
    }

    if (checkIsValidAiAutoTicket) {
        params.checkIsValidAiAutoTicket = true;
    }

    const userId = localStorageUtil.getUserDetailId();
    const selectedProjectId = localStorageUtil.getSelectedProjectId();
    if (userId) {
        params.userId = userId;
    }
    if(selectedProjectId) {
        params.selectedProjectId = selectedProjectId;
    }

    try {
        let queryObject = {
            query: getTicketDetail,
            variables: {
                params: params
            }
        }
        
        if (!authen) {
            queryObject.authMode = Constant.AUTH_MODE_API_KEY
        }

        const res = await API.graphql(queryObject);

        ticketDetail = !Utils.isEmptyObject(res.data.getTicketDetail) ? res.data.getTicketDetail : {};

        ticketDetail.dataShareLink = Utils.convertJSONDataToObject(ticketDetail.dataShareLink);
        
        if (ticketDetail.isDelete) {
            ticketDetail = {};
        }

        return ticketDetail;

    } catch (err) {
        console.log('getTicketById error: ', err);
        return null;
    }
};

export const getTicketDetailAPI = async (APIClient, ticketId, selectedProjectId, currentUserId, isTicketChild) => {
    return new Promise(async (resolve, reject) => {
        try {
            const userId = localStorageUtil.getUserDetailId();
            const selectedPrjId = localStorageUtil.getSelectedProjectId();
            
            const createTicketResult = await API.graphql({
                query: prepareDataForTicketDetail,
                variables: {
                    prepareDataForTicketDetailRequestDto: {
                        ticketId: ticketId,
                        selectedProjectId: selectedProjectId || selectedPrjId,
                        currentUser: currentUserId || userId,
                        isTicketChild: isTicketChild ? isTicketChild : false
                    },
                },
            });
            
            let response = createTicketResult.data.prepareDataForTicketDetail;
            let fieldListData = response?.fieldListData;
            if (fieldListData) {
                const fieldListDataArray = Utils.convertJSONDataToObject(fieldListData);
                const fieldListDataResults = await Promise.all(fieldListDataArray.map(async (field) => {
                    let cloneField = { ...field };
                    const UI = cloneField?.structure?.UI;

                    switch (UI) {
                        case Constant.FIELD_UI.HTML:
                            // get data field Html from S3
                            const htmlS3Link = cloneField?.value;
                            try {
                                const fetchResponse = await fetch(htmlS3Link);
                                const htmlText = await fetchResponse.text();
                                cloneField = { ...cloneField, value: htmlText || '' };
                            } catch (error) {
                                console.error("Can't get data field Html from S3: ", error);
                                cloneField = { ...cloneField, value: '' };
                            }
                            break;
                        case Constant.FIELD_UI.TEXT_AREA:
                            {
                                if (cloneField?.sysField === Constant.SYS_FIELD.SDAUTO_SCRIPT) {
                                    // get data field script from S3
                                    const scriptS3Link = cloneField?.value;
                                    try {
                                        const fetchResponse = await fetch(scriptS3Link);
                                        const scriptText = await fetchResponse.text();
                                        cloneField = { ...cloneField, value: scriptText || '' };
                                    } catch (error) {
                                        console.error("Can't get data field script from S3: ", error);
                                        cloneField = { ...cloneField, value: '' };
                                    }
                                }
                                break;
                            }
                        default:
                            break;
                    }
                    return cloneField;
                }));
                response.fieldListData = JSON.stringify(fieldListDataResults);
            }


            resolve(response);
        } catch (err) {
            console.log('getTicketDetail :>> ', err);
            resolve(err);
        }
    });
};

export const getPdfTicketDetailAPI = async (APIClient, ticketId, selectedProjectId, currentUserId) => {
    try {
        const userId = localStorageUtil.getUserDetailId();
        const ticketRes = await API.graphql({
            query: getTicketPdfDetail,
            variables: {
                params: {
                    ticketId: ticketId,
                    selectedProjectId: selectedProjectId,
                    currentUser: currentUserId || userId,
                },
            },
        });

        return !Utils.isEmptyObject(ticketRes?.data) ? ticketRes?.data.getTicketPdfDetail : {};
    } catch (err) {
        console.log('getPdfTicketDetailAPI :>> ', err);
    }
};

export const createNewTicketAPI = async (APIClient, createTicketRequestBody, authMode) => {
    return new Promise(async (resolve, reject) => {
        try {
            let createTicketRequest = {
                query: createNewTicket,
                variables: createTicketRequestBody
            }

            if(authMode) {
                createTicketRequest.authMode = authMode;
            }

            const createTicketResult = await API.graphql(createTicketRequest);
            resolve(createTicketResult.data.createNewTicket);
        } catch (err) {
            console.log('createNewTicketAPI :>> ', err);
            resolve(err);
        }
    });
};

export const createNewAnonymousQaAPI = async (APIClient, createTicketRequestBody) => {
    return new Promise(async (resolve, reject) => {
        try {
            const createTicketResult = await API.graphql({
                query: createAnonymousQa,
                variables: createTicketRequestBody,
                authMode: AUTH_TYPE.API_KEY,
            });
            resolve(createTicketResult);
        } catch (err) {
            console.log('createAnonymousQa :>> ', err);
            resolve(err);
        }
    });
};

export const saveDraftTicketAPI = async (APIClient, createTicketRequestBody) => {
    return new Promise(async (resolve, reject) => {
        try {
            const createTicketResult = await API.graphql({
                query: saveTicketDraft,
                variables: createTicketRequestBody,
            });
            resolve(createTicketResult.data.saveTicketDraft);
        } catch (err) {
            console.log('saveDraftTicketAPI :>> ', err);
            resolve(err);
        }
    });
};

export const updateTicketInfo = async (APIClient, requestDto) => {
    try {
        const result = await API.graphql({
            query: updateTicket,
            variables: {
                input: {
                    id: requestDto.id,
                    ...requestDto,
                },
            },
        });

        return result.data.updateTicket;
    } catch (err) {
        Logger.error('updateTicket', err);
        return null;
    }
};

export const updateTicketApprove = async (APIClient, requestDto) => {
    try {
        const result = await API.graphql({
            query: editTicket,
            variables: {
                updateTicketRequestDto: requestDto,
            },
            authMode: AUTH_TYPE.API_KEY,
        });

        return result.data.editTicket;
    } catch (err) {
        Logger.error('updateTicket', err);
        return null;
    }
};

export const uploadTicketFileToS3 = async (formData,setFileUploading, oldFileUpdatedList) => { 
    let fileListSuccess = [];
    let listFileError = [];
    let suffixOfAttachments = {};
    let fileDeletedList = [];
    let fileSaveList = [];

    if(!Utils.isEmptyArray(formData.fileUpdatedList)){
        formData?.fileUpdatedList?.forEach((fieLdDetail) =>{
            if(suffixOfAttachments[`${fieLdDetail?.fileName}`]){
                suffixOfAttachments[`${fieLdDetail?.fileName}`] =  suffixOfAttachments[`${fieLdDetail?.fileName}`] +1
            }else{
                suffixOfAttachments[`${fieLdDetail?.fileName}`] = 2
            }
        })
    }

    if (!Utils.isEmptyArray(oldFileUpdatedList)) {
        oldFileUpdatedList.forEach(file => {
            if (file.isDelete) {
                fileDeletedList.push(file);
            } else {
                fileSaveList.push(file);
            }
        })
    }

    if (!Utils.isEmptyArray(fileSaveList)) {
        fileListSuccess = fileListSuccess.concat(fileSaveList);
        fileSaveList.forEach(oldFile => {
            let oldFileExtension = oldFile?.fileName.split('.').pop();
            if (suffixOfAttachments[`${oldFileExtension}`]) {
                suffixOfAttachments[`${oldFileExtension}`] =
                    suffixOfAttachments[`${oldFileExtension}`] + 1;
            } else {
                suffixOfAttachments[`${oldFileExtension}`] = 1;
            }
        })
    }

    if (!Utils.isEmptyArray(fileDeletedList)) {
        fileDeletedList.forEach(file => {
            try {
                Storage.remove(file.url);
            } catch (e) {
            }
        });
    }

    let pushFileProcessList = [];
    let listFileInfo = [];
    let listFileExtension = [];
    const fileNameObj = {};
    const uploadTime = new Date().getTime();
    const affiliationOrganization  = formData?.affiliationOrganization ? formData?.affiliationOrganization : localStorageUtil.getCorporationDomain();

    let listFileCopy = [];
    let listFileAddNew = [];

    for (const fileUpload of formData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME]){
        let fileInfo = cloneDeep(fileUpload);
        const lastDot = fileInfo.file.name.lastIndexOf('.');
        const fileExtension = fileInfo.file.name.substring(lastDot + 1).toLowerCase();
        listFileExtension.push(fileExtension);
        if (fileNameObj[`${fileInfo.file.name}`]) {
            //edit ticket add same file exist
            const timeOfUpload = new Date().getTime();
            const fileName = `${fileInfo.file.name.substring(0, lastDot)}${timeOfUpload}(${
                fileNameObj[`${fileInfo.file.name}`]
            })fileExtension`;
            fileInfo.key = `tmp/${affiliationOrganization}/${uploadTime}/${fileName}`;
            fileNameObj[`${fileInfo.file.name}`] = fileNameObj[`${fileInfo.file.name}`] + 1;

        } else {
            fileNameObj[`${fileInfo.file.name}`] = 1;
            fileInfo.key = `tmp/${affiliationOrganization}/${uploadTime}/${fileInfo.file.name}`;
        }
        listFileInfo.push(fileInfo);

        if (fileInfo.isDuplicate) {
            listFileCopy.push(fileInfo)
            continue;
        }
        listFileAddNew.push(fileInfo)
        pushFileProcessList.push(uploadFileToS3(setFileUploading, fileInfo))
    }

    let pushFileProcessListResult = await Promise.all(pushFileProcessList);

    console.log('listFileInfo---------', listFileInfo)

    for (let i = 0; i < pushFileProcessListResult.length; i++) {
        let fileInfo = findElementByKey(listFileAddNew, pushFileProcessListResult[i]);
        if (pushFileProcessListResult[i]) {
            let dto = {
                fileUrl: fileInfo.key,
                fileSize: fileInfo.file.size.toString(),
                fileName: fileInfo.file.name,
                isPdf: fileInfo.isPdf,
                splitPdf: fileInfo.splitPdf,
                createdAt: new Date()
            }
            if(fileInfo.isPdf) {
                dto.isCreatingPageKnowledge = true;
            }

            fileListSuccess.push(dto);
            if (suffixOfAttachments[`${listFileExtension[i]}`]) {
                suffixOfAttachments[`${listFileExtension[i]}`] =
                    suffixOfAttachments[`${listFileExtension[i]}`] + 1;
            } else {
                suffixOfAttachments[`${listFileExtension[i]}`] = 1;
            }
        } else {
            listFileError.push(fileInfo.file.name);
        }
    }

    if (listFileCopy.length > 0) {
        for (let i = 0; i < listFileCopy.length; i++) {
            let fileCopy = listFileCopy[i];
            let dto = {
                fileUrl: fileCopy.file.path,
                fileSize: fileCopy.file.size.toString(),
                fileName: fileCopy.file.name,
                isPdf: fileCopy.isPdf,
                splitPdf: fileCopy.splitPdf,
                createdAt: new Date(),
                isDuplicate: true
            }
            if(fileCopy.isPdf) {
                dto.isCreatingPageKnowledge = true;
            }

            fileListSuccess.push(dto);
            if (suffixOfAttachments[`${listFileExtension[i]}`]) {
                suffixOfAttachments[`${listFileExtension[i]}`] =
                suffixOfAttachments[`${listFileExtension[i]}`] + 1;
            } else {
                suffixOfAttachments[`${listFileExtension[i]}`] = 1;
            }
        }
    }
  
    return {
        fileListSuccess,
        listFileError,
        suffixOfAttachments,
    };
};

const findElementByKey = (sourceArray, keyObject) => {
    const key = keyObject.key;
    return sourceArray.find(item => item.key === key) || null;
};

export const createTicketRecord = async (APIClient, inputData) => {
    try {
        const input = {
            ...inputData
        }
        const result = await API.graphql({
            query: createTicket,
            variables: {
                input: input
            },
            // Notice: DONOT use authtype API KEY HERE. if need create anonymous QA, use lambda instead of appsync Graphql.
            authMode: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        });

        return result.data.createTicket;
    } catch (err) {
        Logger.error('createTicketRecord', err);
        return null;
    }
};


/**
 * Get ticket item data value
 * @param {*} ticketData 
 * @param {*} dataId 
 * @returns dataValue
 */
export const getTicketItemDataValue = (ticketData, dataId) => {
    let ticketItem = ticketData.find(item => item.dataID === dataId);
    let dataValue = ticketItem ? Utils.convertJSONDataToObject(ticketItem.dataValue) : '';

    return !Utils.isEmpty(dataValue) ? dataValue.value : '';
};


/**
 * Get ticket data
 * @param {*} gqlClient 
 * @param {*} variables 
 * @returns All ticket record
 */
export const queryTicketGSI3ByFilter = async (APIClient, variables) => {
    try {
        let resData = await API.graphql({
            query: queryTicketGSI3,
            variables: variables
        });
        return resData.data.queryTicketGSI3.items;
    } catch (err) {
        console.log('queryTicketGSI3ByFilter error: ', err);
        return null;
    }
};


/**
 * getHelpdeskListDrilldownData
 * @param {*} API 
 * @param {*} args 
 * @returns 
 */
export const getHelpdeskListDrilldownData = async (APIClient, args) => {
    try {
        const requestParams = {
            corporationId: args.corporationId,
            projectId: args.projectId,
            userId: args.userId,
            visibility: args.visibility,
            viewStructure: JSON.stringify(args.viewStructure),
            formatSearch: args.formatSearch,
            from: args?.from,
            size: args?.size
        };

        if (args.searchAfter) {
            requestParams.searchAfter = JSON.stringify(args.searchAfter);
        }

        let params = {
            query: getTicketHelpDeskDrillDownSearch,
            variables: {
                params: requestParams
            }
        };

        let resData = await API.graphql(params);
        let ticketList = resData.data.getTicketHelpDeskDrillDownSearch || [];
        return ticketList;
    } catch (err) {
        console.log('getHelpdeskListDrilldownData error: ', err);
        return [];
    }
};


/**
 * sentTicketFromDraft
 * @param {*} API 
 * @param {*} args 
 * @returns 
 */
export const sentTicketFromDraft = async (APIClient, args) => {
    try {
        const result = await API.graphql({
            query: sendTicketFromDraft,
            variables: {
                sendTicketFromDraftRequestDto: {
                    ticketId: args.ticketId,
                    currentUserId: args.currentUserId,
                    projectInuseId: args.projectInuseId,
                    corporationId: args.corporationId
                },
            },
        });

        return result.data.sendTicketFromDraft;
    } catch (err) {
        Logger.error('sentTicketFromDraft', err);
        return null;
    }
};


/**
 * approveRejectAnonymousQaTicket
 * @param {*} API 
 * @param {*} requestDto 
 * @returns 
 */
export const approveRejectAnonymousQaTicket = async (APIClient, requestDto) => {
    try {
        const result = await API.graphql({
            query: editTicket,
            variables: {
                updateTicketRequestDto: requestDto,
            },
        });

        return result.data.editTicket;
    } catch (err) {
        Logger.error('updateTicket', err);
        return null;
    }
};


/**
 * editTicketData
 * @param {*} API 
 * @param {*} requestDto 
 * @returns 
 */
export const editTicketData = async (APIClient, requestDto) => {
    try {
        const result = await API.graphql({
            query: editTicket,
            variables: {
                updateTicketRequestDto: requestDto,
            },
        });

        return result.data.editTicket;
    } catch (err) {
        Logger.error('updateTicket', err);
        return null;
    }
};



/**
 * getTicketListAssignToUser
 * @param {*} API 
 * @param {*} corporationId 
 * @param {*} projectId 
 * @param {*} userId 
 * @returns 
 */
export const getTicketListAssignToUser = async (APIClient, corporationId, projectId, userId) => {
    try {
        let dynamodbParams = prepareParamsQueryTicketListAssignToUser(Constant.TICKET_USAGE.REQ, corporationId, projectId, userId);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
            // authMode: Constant.AUTH_MODE_API_KEY,
        });

        return !Utils.isEmptyArray(resTicketList.data.getTicketList) ? resTicketList.data.getTicketList : [];
    } catch (err) {
        console.log('getTicketListAssignToUser error: ', err);
        return [];
    }
};

export const getTicketDataGSI3WithFilter = async (APIClient, ticketId, dataType, dataID) => {
    try {
        let dynamodbParams = prepareParamsGetTicketDataGSI3WithFilter(ticketId, dataType, dataID);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
        });

        return !Utils.isEmptyArray(resTicketList.data.getTicketList) ? resTicketList.data.getTicketList : [];
    } catch (err) {
        console.log('getTicketDataGSI3WithFilter error: ', err);
        return [];
    }
}

/**
 *
 * @param {*} meaningStatus
 * @returns
 */
 const getProjectStatus = meaningStatus => {
    switch (meaningStatus) {
        case Constant.INVITATION_FLAG.INVITE_DELETED:
            return Constant.B2B_CUSTOMER_PROJECT_STATUS.DELETED;
        case Constant.INVITATION_FLAG.INVITE_SUCCESS:
            return Constant.B2B_CUSTOMER_PROJECT_STATUS.ACTIVE;
        case Constant.INVITATION_FLAG.INVITE_REJECTED:
            return Constant.B2B_CUSTOMER_PROJECT_STATUS.REJECT;
        case Constant.INVITATION_FLAG.WAITING_APPROVE:
            return Constant.B2B_CUSTOMER_PROJECT_STATUS.WAITING;
        default:
            return Constant.B2B_CUSTOMER_PROJECT_STATUS.WAITING;
    }
};

/**
 *
 * @param {*} API
 * @param {*} project
 * @returns
 */
export const formatResponseB2BCustomerProject = async (APIClient, project) => {
    const orgId = project.affiliationOrganization;
    let orgInfo = await getCorporationById(API, orgId);
    const isNotExistedLogo =  Utils.isEmpty(orgInfo.image) || Utils.isEmptyString(orgInfo.image) ||  Utils.isEmpty(orgInfo.logoFileName) || Utils.isEmptyString(orgInfo.logoFileName) 
    const logoS3Path = `${orgInfo.image}/${orgInfo.logoFileName}`

    return {
        id: project.id,
        logo: isNotExistedLogo ? Constant.LOGO_DEFAULT : await Storage.get(logoS3Path),
        orgName: Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP, orgInfo),
        orgActive: orgInfo?.active,
        projectName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name),
        contractType: orgInfo.contractType,
        status: project.status,
        isTicket: project.isTicket,
        updatedAt: project.updatedAt,
        ticketId: project.ticketId
    };
};

/**
 *
 * @param {*} ticket
 * @returns
 */
export const formatResponseB2BCustomerTicket = ticket => {
    return {
        id: ticket.id,
        logo: Constant.LOGO_DEFAULT,
        orgName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, ticket.orgName),
        projectName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, ticket.projectName),
        orgActive: ticket?.orgActive,
        contractType: Constant.CORPORATION_CONTRACT_TYPE.GUEST,
        status: ticket.status,
        isTicket: ticket.isTicket,
        updatedAt: ticket.updatedAt
    };
};

/**
 * 
 * @param {*} ticket 
 * @returns 
 */
export const formatResponseB2BCustomerTicketOrigin = ticket => {
    return {
        id: ticket.id,
        logo: Constant.LOGO_DEFAULT,
        orgName: ticket.orgName,
        projectName: ticket.projectName,
        contractType: Constant.CORPORATION_CONTRACT_TYPE.GUEST,
        status: ticket.status,
        isTicket: ticket.isTicket,
        updatedAt: ticket.updatedAt
    };
};

/**
 *
 * @param {*} APIClient
 * @param {*} affiliationOrganization
 * @param {*} projectId
 * @returns
 */
export const getWaitingAndRejectB2BCustomerListInProjectFromTicket = async (
    APIClient,
    affiliationOrganization,
    projectId
) => {
    let b2bCustomerList = [];
    try {
        let getWaitingAndRejectB2BCustomerListInProjectFromTicketParams = DynamoDBTicketRequestDto.prepareParamsQueryTicketInviteB2BCustomer(
            Constant.TICKET_USAGE.REQ,
            affiliationOrganization,
            projectId
        );

        let getAllInfoTicketInviteB2BCustomer = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(
                        getWaitingAndRejectB2BCustomerListInProjectFromTicketParams
                    )
                }
            }
        });
        
        getAllInfoTicketInviteB2BCustomer = getAllInfoTicketInviteB2BCustomer.data.getTicketList;
        let [externalInvitationB2BCustomer, guestInvitationB2BCustomer] = getExternalAndGuestInvitation(getAllInfoTicketInviteB2BCustomer);
        let b2bProjectListByInvitationTickets = await Promise.all(
            ticketListToB2BProject(externalInvitationB2BCustomer).map(async b2bProject => {
                let b2bProjectData = await getProjectById(API, b2bProject.projectId);
                return formatResponseB2BCustomerProject(
                    API,
                    Object.assign(b2bProjectData, {
                        id: b2bProject.projectId,
                        status: getStatusB2BProjectListByTicketList(b2bProject),
                        isTicket: false,
                        ticketId: b2bProject.ticketId,
                        updatedAt: b2bProject.updatedAt
                    })
                );
            })
        )

        let b2bGuestInvitationTickets = await Promise.all(
            guestInvitationB2BCustomer.map(async ticket => {
                let ticketInfo = ticket.invitationInfo;
                ticketInfo.status = getStatusGuestTicket(ticket);
                ticketInfo.id = ticket.id;
                ticketInfo.isTicket = true;
                ticketInfo.updatedAt = ticket.updatedAt;
                ticketInfo.ticketId = ticket.id;
                return ticket.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT ? formatResponseB2BCustomerTicketOrigin(ticketInfo): formatResponseB2BCustomerTicket(ticketInfo);
            })
        )
        b2bCustomerList = b2bProjectListByInvitationTickets.concat(b2bGuestInvitationTickets)
        return b2bCustomerList;
    } catch (err) {
        Logger.error('getWaitingAndRejectB2BCustomerListInProjectFromTicket', err);
        return b2bCustomerList;
    }
};

/**
 * 
 * @param {*} ticket 
 * @returns 
 */
const getStatusGuestTicket = ticket => {
    if (
        Utils.isExpired(
            ticket.invitationInfo.expireAt
        )&&(ticket.invitationFlag === Constant.INVITATION_FLAG.WAITING_APPROVE ||
            ticket.invitationFlag === Constant.INVITATION_FLAG.INPROCESS)
    ) {
        return Constant.B2B_CUSTOMER_PROJECT_STATUS.REJECT;
    }
    return getProjectStatus(ticket.invitationFlag);
};

/**
 * 
 * @param {*} b2bProject 
 * @returns 
 */
const getStatusB2BProjectListByTicketList = (b2bProject) => {
    let ticketList = b2bProject.ticketList;
    let lastestUpdate = Date.parse(new Date(ticketList[0].updatedAt));
    let status = ticketList[0].invitationFlag;
    for(let i=0; i<ticketList.length; i++){
        if(ticketList[i].liveOrArchived === Constant.LIVE_OR_ARCHIVED.LIVE){
            return Constant.B2B_CUSTOMER_PROJECT_STATUS.WAITING;
        }
        if(ticketList[i].invitationFlag === Constant.INVITATION_FLAG.INVITE_SUCCESS){
            return Constant.B2B_CUSTOMER_PROJECT_STATUS.ACTIVE;
        }
        if(lastestUpdate <= Date.parse(new Date(ticketList[i].updatedAt))){
            lastestUpdate = Date.parse(new Date(ticketList[i].updatedAt));
            status = ticketList[i].invitationFlag;
        }
    }
    return getProjectStatus(status);
}

/**
 * 
 * @param {*} tickeList 
 * @returns 
 */
const getExternalAndGuestInvitation = (tickeList) => {
    let externalInvitationB2BCustomer = []; 
    let guestInvitationB2BCustomer = [];
    tickeList.forEach(ticket => {
        if(ticket.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER || ticket.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK){
            externalInvitationB2BCustomer.push(ticket);
        }
        if(ticket.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT){
            guestInvitationB2BCustomer.push(ticket);
        }
    })
    return [externalInvitationB2BCustomer, guestInvitationB2BCustomer]
}

/**
 * 
 * @param {*} b2bProjectList 
 * @param {*} projectId 
 * @returns 
 */
const isExistB2BProject = (b2bProjectList, projectId) => {
    let status = false;
    b2bProjectList.forEach(project => {
        if(project.projectId === projectId){
            status = true;
        }
    })
    return status
}

/**
 * 
 * @param {*} b2bProjectList 
 * @param {*} projectId 
 * @returns 
 */
const findIndexOfListB2B  = (b2bProjectList, projectId) => {
    let indexOfProject = -1;
    b2bProjectList.forEach((project, index) => {
        if(project.projectId === projectId){
            indexOfProject = index;
        }
    })
    return indexOfProject;
}

/**
 * 
 * @param {*} ticketList 
 * @returns 
 */
export const ticketListToB2BProject = (ticketList) => {
    let result = [];
    ticketList.forEach(ticket => {
        let projectId;
        if(ticket.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER && !Utils.isEmptyArray(ticket.projectTarget)){
            projectId = ticket.projectTarget[0];
        }
        if(ticket.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK && !Utils.isEmptyString(ticket.projectOrigin)){
            projectId = ticket.projectOrigin;
        }
        if(!isExistB2BProject(result, projectId)){
            result.push({
                projectId: projectId,
                ticketList: [ticket],
                updatedAt: ticket.updatedAt
            })
        }
        else{
            let index = findIndexOfListB2B(result, projectId)
            if(index !== -1){
                result[index].ticketList.push(ticket)
                result[index].updatedAt = result[index].updatedAt > ticket.updatedAt ? result[index].updatedAt : ticket.updatedAt;
            }
        }
    });

    if (!Utils.isEmptyArray(result)) {
        result = result.map(project => {
            if (!Utils.isEmptyArray(project.ticketList)) {
                let sortTicketList =  Utils.sortByUpdatedAtDesc(project.ticketList)
                project.ticketList = sortTicketList;
                project.ticketId = sortTicketList[0].id;
                project.updatedAt = sortTicketList[0].updatedAt;
            }
            return project;
        })
    }
    return result;
}

/**
 * 
 * @param {*} API 
 * @param {*} affiliationOrganization 
 * @param {*} projectId 
 * @returns 
 */
export const getTicketInviteB2BCustomerByProjectId = async(APIClient, affiliationOrganization, projectId) => {
    let ticketListByProjectId = [];
    try{
        let getTicketParams = DynamoDBTicketRequestDto.prepareParamsQueryTicketInviteB2BCustomer(
            Constant.TICKET_USAGE.REQ,
            affiliationOrganization,
            projectId
        );
        ticketListByProjectId = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(
                        getTicketParams
                    )
                }
            }
        });
        return ticketListByProjectId;
    }catch(err){
        Logger.error('getListTicketRequestByProjectId', err);
        return ticketListByProjectId;
    }
}


/**
 * getTicketListOfCustomerUser
 * get list ticket of customer user
 * @param {*} API 
 * @param {*} corporationId 
 * @param {*} guestCustomerProjectId 
 * @param {*} userId 
 * @returns 
 */
export const getTicketListOfCustomerUser = async (APIClient, corporationId, userId) => {
    try {
        let projectGuestCustomerId = '';
        let projectGuestCustomerData = await getCustomerProjectByCorporation(API, corporationId);
        if (projectGuestCustomerData && !Utils.isEmptyObject(projectGuestCustomerData)) {
            projectGuestCustomerId = projectGuestCustomerData.id;
        }

        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsGetTicketListOfCustomerUser(Constant.TICKET_USAGE.REQ, corporationId, null, userId, projectGuestCustomerId);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
        });

        return !Utils.isEmptyArray(resTicketList.data.getTicketList) ? resTicketList.data.getTicketList : [];
    } catch (err) {
        console.log('getTicketListOfCustomerUser error: ', err);
        return [];
    }
}


/**
 * getTicketListBetweenTwoProject
 * @param {*} API 
 * @param {*} projectOrigin 
 * @param {*} projectTarget 
 */
export const getTicketListBetweenTwoProject = async (APIClient, projectOrigin, projectTarget) => {
    try {
        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsGetTicketListBetweenTwoProject(Constant.TICKET_USAGE.REQ, projectOrigin, projectTarget);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
        });

        return !Utils.isEmptyArray(resTicketList.data.getTicketList) ? resTicketList.data.getTicketList : [];
    } catch (err) {
        console.log('getTicketListBetweenTwoProject error: ', err);
        return [];
    }
}


/**
 * getTicketListCreatedByUser
 * get all ticket created by user id
 * @param {*} API 
 * @param {*} userId 
 * @returns 
 */
export const getTicketListCreatedByUser = async (APIClient, userId) => {
    try {
        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsGetTicketListCreatedByUser(Constant.TICKET_USAGE.REQ, userId);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
        });

        return !Utils.isEmptyArray(resTicketList.data.getTicketList) ? resTicketList.data.getTicketList : [];
    } catch (err) {
        console.log('getTicketListCreatedByUser error: ', err);
        return [];
    }
};


/**
 * getAllTicketInCustomerAndHelpdeskSide
 * @param {*} API 
 * @param {*} userId 
 * @param {*} projectId 
 * @returns 
 */
export const getAllTicketInCustomerAndHelpdeskSide = async (APIClient, corporationId, projectId) => {
    try {
        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsGetAllTicketHelpdeskSide(Constant.TICKET_USAGE.REQ, corporationId, projectId);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resHelpdesk = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
        });

        let paramsCustomer = DynamoDBTicketRequestDto.prepareParamsGetAllTicketCustomerSide(projectId);
        let resCustomer = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(paramsCustomer)
                }
            },
        });

        return (resHelpdesk.data.getTicketList).concat(resCustomer.data.getTicketList);
    } catch (err) {
        console.log('getAllTicketInCustomerAndHelpdeskSide error: ', err);
        return [];
    }
}


/**
 * getAllTicketBetweenHelpdeskAndCustomerProject
 * @param {*} API 
 * @param {*} affiliationOrganization 
 * @param {*} affiliationProject 
 * @param {*} customer 
 * @returns 
 */
export const getAllTicketBetweenHelpdeskAndCustomerProject = async (
    APIClient,
    affiliationOrganization,
    affiliationProject,
    customer
) => {
    try {
        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsGetAllTicketBetweenHelpdeskAndCustomerProject(
            Constant.TICKET_USAGE.REQ,
            affiliationOrganization,
            affiliationProject,
            customer
        );

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            }
        });

        return !Utils.isEmptyArray(resTicketList.data.getTicketList)
            ? resTicketList.data.getTicketList
            : [];
    } catch (err) {
        console.log('getAllTicketBetweenHelpdeskAndCustomerProject error: ', err);
        return [];
    }
};


/**
 * getTicketListBetweenProjectAndB2C
 * @param {*} API 
 * @param {*} corporationId 
 * @param {*} affiliationProject 
 * @param {*} userId 
 * @returns 
 */
export const getTicketListBetweenProjectAndB2C = async (APIClient, corporationId, affiliationProject, userId) => {
    try {
        let projectGuestCustomerId = '';
        let projectGuestCustomerData = await getCustomerProjectByCorporation(API, corporationId);
        if (projectGuestCustomerData && !Utils.isEmptyObject(projectGuestCustomerData)) {
            projectGuestCustomerId = projectGuestCustomerData.id;
        }

        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsGetTicketListOfCustomerUser(Constant.TICKET_USAGE.REQ, corporationId, affiliationProject, userId, projectGuestCustomerId);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
        });

        return !Utils.isEmptyArray(resTicketList.data.getTicketList) ? resTicketList.data.getTicketList : [];
    } catch (err) {
        console.log('getTicketListBetweenProjectAndB2C error: ', err);
        return [];
    }
}


/**
 * archiveTicketList
 * @param {*} APIClient 
 * @param {*} ticketList 
 * @returns 
 */
export const archiveTicketList = async (APIClient, ticketList, currentUserId) => {
    if (Utils.isEmptyArray(ticketList)) {
        return true;
    }

    try {
        let promiseUpdate = [];
        ticketList.forEach(ticket => {
            let objArchiveTicket = {
                id: ticket.id,
                usage: ticket.usage,
                affiliationOrganization: ticket.affiliationOrganization,
                affiliationProject: ticket.affiliationProject,
                readPermission: ticket.readPermission,
                createdAt: ticket.createdAt,
                liveOrArchived: Constant.LIVE_OR_ARCHIVED.ARCHIVED,
                public: Constant.TICKET_PUBLIC.PUBLIC,
                updatedForCustomer: Utils.setUpdatedTicketObject(ticket?.updatedForCustomer, currentUserId),
                updatedForDesk: Utils.setUpdatedTicketObject(ticket?.updatedForDesk, currentUserId)
            }

            promiseUpdate.push(updateTicketInfo(API, objArchiveTicket));
        });

        await Promise.all(promiseUpdate);
        return true;
    } catch (err) {
        console.log('archiveTicketList error: ', err);
        return false;
    }
}


/**
 * getTicketListToArchivedAfterDeleteUserFromCorporation
 * @param {*} APIClient 
 * @param {*} corporationId 
 * @param {*} userId 
 * @param {*} projectBaseId 
 * @returns 
 */
export const getTicketListToArchivedAfterDeleteUserFromCorporation = async (APIClient, corporationId, userId, projectBaseId) => {
    try {
        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsGetTicketListToArchivedAfterDeleteUser(Constant.TICKET_USAGE.REQ, corporationId, userId, projectBaseId);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
        });

        return !Utils.isEmptyArray(resTicketList.data.getTicketList) ? resTicketList.data.getTicketList : [];
    } catch (err) {
        console.log('getTicketListToArchivedAfterDeleteUserFromCorporation error: ', err);
        return [];
    }
};

export const getActiveHelpdeskTicketList = async(APIClient, corporationId, projectInuseId) => {
    try {
        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsGetActiveHelpdeskTicketList(corporationId, projectInuseId);
        let dynamodbTaskParams = DynamoDBTicketRequestDto.prepareParamsGetActiveHelpdeskTaskTicketList(corporationId, projectInuseId);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        const [resTicketList, resTaskTicketList] = await Promise.all([
            API.graphql({
                query: getTicketList,
                variables: {
                    params: {
                        expression: JSON.stringify(dynamodbParams)
                    }
                }
            }),
            API.graphql({
                query: getTicketList,
                variables: {
                    params: {
                        expression: JSON.stringify(dynamodbTaskParams)
                    }
                }
            })
        ]);

        let result = [];

        if (!Utils.isEmptyArray(resTicketList.data.getTicketList)) {
            result = result.concat(resTicketList.data.getTicketList);
        }
        if (!Utils.isEmptyArray(resTaskTicketList.data.getTicketList)) {
            result = result.concat(resTaskTicketList.data.getTicketList);
        }

        return result
    } catch (err) {
        console.log('getActiveHelpdeskTicketList error: ', err);
        return [];
    }
}

/**
 * deleteAllTicketData
 * delete ticket data, ticket child, ticket value and usingTicket in form
 * @param {*} API 
 * @param {*} ticketId 
 * @returns 
 */
export const deleteAllTicketData = async (APIClient, requestDto) => {
    try {
        const result = await API.graphql({
            query: removeTicket,
            variables: {
                removeTicketRequestDto: requestDto,
            },
        });

        return result.data.removeTicket;
    } catch (err) {
        Logger.error('deleteAllTicketData', err);
        return null;
    }
}

/**
 * deleteTicketById
 * @param {*} API 
 * @param {*} id 
 * @returns 
 */
export const deleteTicketById = async (APIClient, id) => {
    try {
        const result = await API.graphql({
            query: deleteTicket,
            variables: {
                input: {
                    id: id,
                },
            },
        });

        return result.data.deleteTicket;
    } catch (err) {
        Logger.error('deleteTicket', err);
        return null;
    }
}


/**
 * queryTicketListByGSI3
 * @param {*} API 
 * @param {*} ticketId 
 * @param {*} dataType 
 * @param {*} dataLang 
 * @returns 
 */
export const queryTicketListByGSI3 = async (APIClient, ticketId, dataType, dataLang) => {
    try {
        let dynamodbParams = DynamoDBTicketRequestDto.prepareParamsQueryTicketByGSI3(ticketId, dataType, dataLang);

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resTicketList = await API.graphql({
            query: getTicketList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            },
        });
        return !Utils.isEmptyArray(resTicketList.data.getTicketList) ? resTicketList.data.getTicketList : [];
    } catch (err) {
        console.log('queryTicketByGSI3 error: ', err);
        return [];
    }
}


export const queryListMasterKnowledgeTicketOfForm = async (APIClient, organizationId, projectId, formId,userInfo) => {
    try {
        console.log('resTicketList :>> ', 1);
        let params = {
            affiliationOrganization: organizationId,
            affiliationProject: projectId,
            formId: formId,
            actionType: Constant.QUERY_ELS_ACTION_TYPE.GET_MATER_KNOWLEDGE_OF_FORM,
            ...userInfo
        }
        let resTicketList = await API.graphql({
            query: executeQueryEls,
            variables: {
                params: JSON.stringify(params)
            },
        });
        let data = resTicketList?.data?.executeQueryEls;
        let listTicket = []
        if(data.success){
            listTicket = Utils.convertJSONDataToObject(data.payload)
        }
        console.log('resTicketList :>> ', listTicket);
        return listTicket
    } catch (err) {
        console.log('queryTicketByGSI3 error: ', err);
        return [];
    }
}

export const queryListMasterKnowledgeItemWithShortenedData = async (organizationId, projectId, formId, userInfo) => {
    try {
        let params = {
            affiliationOrganization: organizationId,
            affiliationProject: projectId,
            formId: formId,
            actionType: Constant.QUERY_ELS_ACTION_TYPE.GET_TAG_MASTER_CHILD_WITH_SHORTENED_DATA,
            ...userInfo
        }
        
        let resTicketList = await API.graphql({
            query: executeQueryEls,
            variables: {
                params: JSON.stringify(params)
            },
        });
        let data = resTicketList?.data?.executeQueryEls;
        let listTicket = [];

        if(data.success) {
            listTicket = Utils.convertJSONDataToObject(data.payload)
        }

        return listTicket;
    } catch (err) {
        console.log('queryListMasterKnowledgeItemWithShortenedData error: ', err);
        return [];
    }
}

export const queryListMasterKnowledgeTicketOfFormWithPagination = async (
    APIClient,
    organizationId,
    projectId,
    formId,
    userInfo,
    nextToken,
    defaultMasterItemIds
) => {
    try {
        let params = {
            affiliationOrganization: organizationId,
            affiliationProject: projectId,
            formId: formId,
            actionType: Constant.QUERY_ELS_ACTION_TYPE.GET_MATER_KNOWLEDGE_OF_FORM_WITH_PAGINATION,
            nextToken,
            defaultMasterItemIds,
            ...userInfo
        };
        let resTicketList = await API.graphql({
            query: executeQueryEls,
            variables: {
                params: JSON.stringify(params)
            }
        });
        const data = resTicketList?.data?.executeQueryEls;

        let listTicket = [];
        if (data.success) {
            const result = Utils.convertJSONDataToObject(data.payload);
            listTicket = result?.listTicketWithPermissionOfUser || result;

            return {
                listTicket,
                nextToken: result?.nextToken
            };
        }
  
        return {
            listTicket: [],
            nextToken: null
        };
    } catch (err) {
        console.log('queryTicketByGSI3 error: ', err);
        return [];
    }
};

export const getListMasterKnowledgeTicketOfFormWithoutAuthen = async (APIClient, organizationId, projectId, formId) => {
    if (!API || !formId || !organizationId || !projectId) return;

    try {
        let response;

        let params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_LIST_MASTER_KNOWLEDGE_OF_FORM,
            isGetTitle: true,
            organizationId: organizationId,
            projectId: projectId,
            formId: formId
        }

        let getFormResult = await getPublicAPI(API, params);
        if (getFormResult.success) {
            response = Utils.convertJSONDataToObject(getFormResult.payload)?.ticketListResult;
        }

        return response;
    } catch (err) {
        console.log('getFormByIdWithoutAuthen error: ', err);
        return {};
    }
}

export const checkDetailTicket = async (APIClient, id) => {
    let ticket  = await getTicketById(API, id);
    if (!ticket || Utils.isEmptyObject(ticket) || (ticket && ticket.id === null)) {
        return {status: Constant.TICKET_DELETED_STATUS.REMOVED}
    }
    if (!ticket.deletedAt && ticket.anonymousQaStatus !== Constant.ANONYMOUS_TICKET_STATUS.END_LIVE_CHAT) {
        return {status: Constant.TICKET_DELETED_STATUS.INUSED}
    }
    return {status: Constant.TICKET_DELETED_STATUS.TERM_REMOVED}
}

/**
 * Check user has view permission when click view detail, click icon chat in list ticket knowledge 
 * @param {*} APIClient 
 * @param {*} currentProject 
 * @param {*} userId 
 * @param {*} isViewDetail 
 * @returns 
 */
export const checkViewPermissionKnowDetailInList =  (APIClient, ticket, currentProject, userId, isViewDetail = false) => {
    return hasKnowledgeChatPermissionInChatThread(ticket, currentProject, userId, isViewDetail);
}

/**
 * getDetailTicketInTicketList
 * @param {*} APIClient 
 * @param {*} params 
 * @returns 
 */
export const getDetailTicketInTicketList = async (APIClient, params) => {
    let queryParams = {
        query: getTicketListDetail,
        variables: {
            params: params,
        },
    };
    let queryResult = await API.graphql(queryParams);

    let detailTicket = queryResult?.data?.getTicketListDetail || {};
    return detailTicket;
};

export const createNewTicketByUploadCsv = async (APIClient, params) => {
    return new Promise(async (resolve, reject) => {
        try {
            let createTicketRequest = {
                query: createTicketByUploadCsv,
                variables: {
                    createTicketByUploadCsvRequestDto: params}
            }

            const createTicketResult = await API.graphql(createTicketRequest);
            resolve(createTicketResult.data.createTicketByUploadCsv);
        } catch (err) {
            console.log('createTicketByUploadCsv :>> ', err);
            resolve(err);
        }
    });
};

export const getTicketsKnowledgePrompt = async (APIClient, params) => {
    try {
        let queryParams = {
            query: getTicketKnowledgePrompt,
            variables: {
                params
            }
        };
    
        let result = await API.graphql(queryParams);
        return result.data?.getTicketKnowledgePrompt;
    } catch (error) {
        console.log('getTicketsKnowledgePrompt :>> ', error);
        return [];
    }
   
}

export const handleBulkUpdateTicket = async (params) => {
    try {
        let queryParams = {
            query: bulkUpdateTicket,
            variables: {
                bulkUpdateTicketRequestDto: params
            }
        };
    
        let result = await API.graphql(queryParams);
        console.log('handleBulkUpdateTicket >>> result >>>', result);

        return result.data?.bulkUpdateTicket;
    } catch (error) {
        console.log('handleBulkUpdateTicket >>>', error);
        return '';
    }
}